import React, { useEffect, useState } from "react";
import { IoMdCheckmark } from "react-icons/io";
import { FaTimes } from "react-icons/fa";

function Pricing({ prices, pricingType, tieredAmex, isAch, billingInfo }) {
    const [default_prices, setDefaultPrices] = useState([]);
    const [dual_pricing, setDualPricing] = useState([]);
    const [surcharge, setSurcharge] = useState([]);
    const [flat_rate, setFlatRate] = useState([]);
    const [tiered, setTiered] = useState([]);
    const [ach, setAch] = useState([]);

    const ach_prices_ids = [
        50, // discount rate & txn fee
        51, // Statement fee
        52, // Monthly minimum
        53, // Return fee
        54, // NOC fee
        55, // Unauthorized return fee
        56, // Same day fee
        57, // Returned item fee
    ];
    
    useEffect(() => {
        let default_prices_ids = [
            28, //'setup fee', //
            19, //'Monthly Access Fee', //
            18, //'Monthly Minimum', //
            12, //'Voice ARU', //
            14, //'Batch Fee', //
            29, //'EBT Transactions', //
            13, //'AVS Fee', //
            11, //'3rd Party Auth/Txn', //
            42, //'$100k Data Breach', //
            43, //'Semi-Annual Tech Fee', //
            44, //'Monthly Cellular Txn', //
            45, //'Cellular/Txn', //
            46, //'ETF Fee', //
            22, //'Returned ACH Item', //
            20, //'Chargeback Fee', //
            47, //'Representment Fee', //
            48, //'Pre-Dispute Fee', //
        ];

        let dual_prices_ids = [
            35, // Dual pricing rate,
            17, // Monthly fee,
            5, // pin debit
        ];

        let surcharge_prices_ids = [
            35, // Dual pricing rate,
            17, // Monthly fee
            5, // pin debit
            6, // signature debit
            39, // Qual
            40, // Mid qual
            41, // non dual
        ];

        let flat_rate_prices_ids = [
            2, // Flat rate,
            35, // Amex
            5, // pin debit
            // 36,  // network fee
        ];

        let tired_prices_ids = [
            1, // qual
            3, // mid
            4, // non

            39, // qual debit
            40, // mid debit
            41, // non debit

            32, // amex qual
            33, // amex mid
            34, // amex non
            49, // amex non

            35, // Amex Flat/IC+
        ];

        let default_prices = prices
            .filter((item) => default_prices_ids.includes(item.id))
            .map((item) => ({
                pricing_title: item.title,
                dollars: item.pivot.dollars,
            }));
        setDefaultPrices(default_prices);

        let dual_pricing = prices.filter((item) =>
            dual_prices_ids.includes(item.id),
        );
        setDualPricing(dual_pricing);

        let surcharge_pricing = prices.filter((item) =>
            surcharge_prices_ids.includes(item.id),
        );
        setSurcharge(surcharge_pricing);

        let flat_rate_pricing = prices.filter((item) =>
            flat_rate_prices_ids.includes(item.id),
        );
        setFlatRate(flat_rate_pricing);

        let tiered_pricing = prices.filter((item) =>
            tired_prices_ids.includes(item.id),
        );
        setTiered(tiered_pricing);

        let ach_pricing = prices.filter((item) =>
            ach_prices_ids.includes(item.id),
        );
        setAch(ach_pricing);
    }, []);

    return (
        <div>
            {/* Dual Pricing */}
            {pricingType == "dual_pricing" && (
                <div className="row">
                    {dual_pricing.map((price) => {
                        if (price.id == 35) {
                            return (
                                <div className="col-md-6 col-sm-6 col-xs-6">
                                    <p className={"form-control-static"}>
                                        <b>Dual Pricing Rate</b>:{" "}
                                        {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                    </p>
                                </div>
                            );
                        } else if (price.id == 5) {
                            return (
                                <>
                                    <h4 className="text-center">
                                        PIN-based Debit
                                    </h4>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Debit Rate</b>: {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                        </p>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Per Txn</b>: {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                        </p>
                                    </div>
                                </>
                            );
                        } else {
                            return (
                                <div className="col-md-6 col-sm-6 col-xs-6">
                                    <p className={"form-control-static"}>
                                        <b>{"Monthly Fee"}</b>: {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                    </p>
                                </div>
                            );
                        }
                    })}
                </div>
            )}

            {/* Surcharge */}
            {pricingType == "surcharge" && (
                <div className="row">
                    {surcharge.map((price) => {
                        if (price.id == 35) {
                            return (
                                <>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Surcharge Rate</b>:{" "}
                                            {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                        </p>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Per Txn</b>:{" "}
                                            {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                        </p>
                                    </div>
                                </>
                            );
                        }

                        if (price.id == 5) {
                            return (
                                <>
                                    <h4 className="text-center">
                                        PIN-based Debit
                                    </h4>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Debit Rate</b>: {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                        </p>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Per Txn</b>: {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                        </p>
                                    </div>
                                </>
                            );
                        }

                        if (tieredAmex == "tiered" && price.id == 39) {
                            return (
                                <>
                                    <h4 className="text-center">
                                        Debit Structure: Tiered
                                    </h4>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Qualified Debit Rate</b>: {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                        </p>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Qualified Debit Per Txn</b>: {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                        </p>
                                    </div>
                                </>
                            );
                        }

                        if (tieredAmex == "tiered" && price.id == 40) {
                            return (
                                <>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Mid Qualified Debit Rate</b>: {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                        </p>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Min Qualified Debit Per Txn</b>: {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                        </p>
                                    </div>
                                </>
                            );
                        }

                        if (tieredAmex == "tiered" && price.id == 41) {
                            return (
                                <>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Non Qualified Debit Rate</b>: {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                        </p>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Non Qualified Debit Per Txn</b>: {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                        </p>
                                    </div>
                                </>
                            );
                        }

                        if (tieredAmex == "ic_plus" && price.id == 6) {
                            return (
                                <>
                                    <h4 className="text-center">
                                        Debit Structure: IC +
                                    </h4>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>IC+ Debit Rate</b>: {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                        </p>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>IC+ Debit Per Txn</b>: {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                        </p>
                                    </div>
                                </>
                            );
                        }

                        if (price.id == 17) {
                            return (
                                <>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>{"Monthly Fee"}</b>: {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                        </p>
                                    </div>
                                </>
                            );
                        }
                    })}
                </div>
            )}

            {/* Flat Rate */}
            {pricingType == "flat_rate" && (
                <div className="row">
                    {flat_rate.map((price) => {
                        if (price.id == 2) {
                            return (
                                <>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Flat Rate</b>:{" "}
                                            {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                        </p>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Txn Fee</b>:{" "}
                                            {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                        </p>
                                    </div>
                                </>
                            );
                        }

                        if (price.id == 35) {
                            return (
                                <>
                                    <h4 className="text-center">AMEX</h4>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>AMEX Flat Rate</b>:{" "}
                                            {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                        </p>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>AMEX Txn Fee</b>:{" "}
                                            {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                        </p>
                                    </div>
                                </>
                            );
                        }

                        if (price.id == 5) {
                            return (
                                <>
                                    <h4 className="text-center">
                                        PIN-based Debit
                                    </h4>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Debit Rate</b>: {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                        </p>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Per Txn</b>: {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                        </p>
                                    </div>
                                </>
                            );
                        }

                        if (price.id == 36) {
                            return (
                                <div className="col-md-6 col-sm-6 col-xs-6">
                                    <p className={"form-control-static"}>
                                        <b>{price.title}</b>: {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                    </p>
                                </div>
                            );
                        }
                    })}
                </div>
            )}

            {/* Tiered */}
            {pricingType == "tiered" && (
                <div className="row">
                    {tiered.map((price) => {
                        if (price.id == 1) {
                            return (
                                <>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Qual Rate</b>:{" "}
                                            {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                        </p>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Txn Fee</b>:{" "}
                                            {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                        </p>
                                    </div>
                                </>
                            );
                        }

                        if (price.id == 3) {
                            return (
                                <>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Mid-Qual Rate</b>:{" "}
                                            {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                        </p>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Txn Fee</b>:{" "}
                                            {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                        </p>
                                    </div>
                                </>
                            );
                        }

                        if (price.id == 4) {
                            return (
                                <>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Non-Qual Rate</b>:{" "}
                                            {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                        </p>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Txn Fee</b>:{" "}
                                            {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                        </p>
                                    </div>
                                </>
                            );
                        }

                        if (price.id == 39) {
                            return (
                                <>
                                    <h4 className="text-center">
                                        Pin-Based Debit
                                    </h4>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Qual Debit Rate</b>:{" "}
                                            {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                        </p>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Qual Debit Per Txn</b>:{" "}
                                            {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                        </p>
                                    </div>
                                </>
                            );
                        }

                        if (price.id == 40) {
                            return (
                                <>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Mid-Qual Debit Rate</b>:{" "}
                                            {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                        </p>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Mid-Qual Debit Per Txn</b>:{" "}
                                            {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                        </p>
                                    </div>
                                </>
                            );
                        }

                        if (price.id == 41) {
                            return (
                                <>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Non-Qual Debit Rate</b>:{" "}
                                            {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                        </p>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>Non-Qual Debit Per Txn</b>:{" "}
                                            {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                        </p>
                                    </div>
                                </>
                            );
                        }

                        if (tieredAmex == "tiered") {
                            if (price.id == 32) {
                                return (
                                    <>
                                        <h4 className="text-center">
                                            Debit Structure: Tiered
                                        </h4>
                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                            <p className={"form-control-static"}>
                                                <b>AMEX Tier 1</b>: {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                            </p>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                            <p className={"form-control-static"}>
                                                <b>AMEX Tier 1 Txn Fee</b>: {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                            </p>
                                        </div>
                                    </>
                                );
                            }
                            if (price.id == 33) {
                                return (
                                    <>
                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                            <p
                                                className={
                                                    "form-control-static"
                                                }
                                            >
                                                <b>AMEX Tier 2 Rate</b>:{" "}
                                                {price.pivot.percent}%
                                            </p>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                            <p
                                                className={
                                                    "form-control-static"
                                                }
                                            >
                                                <b>AMEX Tier 2 Txn Fee </b>:{" "}
                                                {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                            </p>
                                        </div>
                                    </>
                                );
                            }
                            if (price.id == 34) {
                                return (
                                    <>
                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                            <p
                                                className={
                                                    "form-control-static"
                                                }
                                            >
                                                <b>AMEX Tier 3 Rate</b>:{" "}
                                                {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                            </p>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                            <p
                                                className={
                                                    "form-control-static"
                                                }
                                            >
                                                <b>AMEX Tier 3 Txn Fee </b>:{" "}
                                                {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                            </p>
                                        </div>
                                    </>
                                );
                            }

                            if (price.id == 49) {
                                return (
                                    <>
                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                            <p
                                                className={
                                                    "form-control-static"
                                                }
                                            >
                                                <b>AMEX Tier 4 Rate</b>:{" "}
                                                {price.pivot.percent}%
                                            </p>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                            <p
                                                className={
                                                    "form-control-static"
                                                }
                                            >
                                                <b>AMEX Tier 4 Txn Fee </b>:{" "}
                                                {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                            </p>
                                        </div>
                                    </>
                                );
                            }
                        }

                        if (tieredAmex == "flat_rate") {
                            if (price.id == 35) {
                                return (
                                    <>
                                        <h4 className="text-center">AMEX</h4>
                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                            <p
                                                className={
                                                    "form-control-static"
                                                }
                                            >
                                                <b>AMEX Flat Rate</b>:{" "}
                                                {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                            </p>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                            <p
                                                className={
                                                    "form-control-static"
                                                }
                                            >
                                                <b>AMEX Txn Fee</b>:{" "}
                                                {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                            </p>
                                        </div>
                                    </>
                                );
                            }
                        }

                        if (tieredAmex == "ic_plus") {
                            if (price.id == 35) {
                                return (
                                    <>
                                        <h4 className="text-center">
                                            Debit Structure: IC+
                                        </h4>
                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                            <p
                                                className={
                                                    "form-control-static"
                                                }
                                            >
                                                <b>AMEX IC+ Rate</b>:{" "}
                                                {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                            </p>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-xs-6">
                                            <p
                                                className={
                                                    "form-control-static"
                                                }
                                            >
                                                <b>AMEX IC+ Txn Fee</b>:{" "}
                                                {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                            </p>
                                        </div>
                                    </>
                                );
                            }
                        }
                    })}
                </div>
            )}

            {/* Flat Rate */}
            {pricingType == "ic_plus" && (
                <div className="row">
                    {flat_rate.map((price) => {
                        if (price.id == 2) {
                            return (
                                <>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>IC+ Rate</b>:{" "}
                                            {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                        </p>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>IC+ Txn Fee</b>:{" "}
                                            {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                        </p>
                                    </div>
                                </>
                            );
                        }

                        if (price.id == 35) {
                            return (
                                <>
                                    <h4 className="text-center">AMEX</h4>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>AMEX IC+ Rate</b>:{" "}
                                            {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                        </p>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>AMEX IC+ Txn Fee</b>:{" "}
                                            {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                        </p>
                                    </div>
                                </>
                            );
                        }

                        if (price.id == 5) {
                            return (
                                <>
                                    <h4 className="text-center">Pin Debit</h4>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>PIN Debit Rate</b>: {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                        </p>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>PIN Debit Per Txn</b>: {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                        </p>
                                    </div>
                                </>
                            );
                        }

                        if (price.id == 36) {
                            return (
                                <div className="col-md-6 col-sm-6 col-xs-6">
                                    <p className={"form-control-static"}>
                                        <b>{price.title}</b>: {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                    </p>
                                </div>
                            );
                        }
                    })}
                </div>
            )}

            {/* ACH */}
            {(pricingType == "ach" || isAch) && (
                <>
                    <h4 className="text-center">ACH Pricing</h4>
                    <div className="row">
                        {ach.map((price, index) => {
                            if (price.id == 50) {
                            return (
                                <>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>ACH Discount Rate</b>:{" "}
                                            {price.pivot.percent ? `${price.pivot.percent}%` : '--'}
                                        </p>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>ACH Txn Fee Per Item</b>:{" "}
                                            {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                        </p>
                                    </div>
                                </>
                            );
                        }
                        else
                        {
                            return (
                                <>
                                    {index == 1 && (
                                        <h6 className="text-center">ACH Fees</h6>
                                    )}
                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                        <p className={"form-control-static"}>
                                            <b>{price.title}</b>: {price.pivot.dollars ? `$${price.pivot.dollars}` : '--'}
                                        </p>
                                    </div>
                                </>
                            );
                        }
                    })}
                </div>
                <div className="row mt-3">
                    <div className="col-12">
                        <h6 className="text-center">ACH Services</h6>
                        <div className="">
                            <div className="col-md-6 col-sm-6 mb-2">
                                <p className="form-control-static d-flex align-items-center" style={{ gap: '1em'}}>
                                ACH by Phone (TEL) {billingInfo?.ach_by_phone ? 
                                    <IoMdCheckmark className="text-success ms-2" style={{ fontSize: '1.8rem' }} /> : 
                                    <FaTimes className="text-danger ms-2" style={{ fontSize: '1.8rem' }} />}
                                </p>
                            </div>
                            <div className="col-md-6 col-sm-6 mb-2">
                                <p className="form-control-static d-flex align-items-center" style={{ gap: '1em'}}>
                                ACH by Web (WEB) {billingInfo?.ach_by_web ? 
                                    <IoMdCheckmark className="text-success ms-2" style={{ fontSize: '1.8rem' }} /> : 
                                    <FaTimes className="text-danger ms-2" style={{ fontSize: '1.8rem' }} />}
                                </p>
                            </div>
                            <div className="col-md-6 col-sm-6 mb-2">
                                <p className="form-control-static d-flex align-items-center" style={{ gap: '1em'}}>
                                ACH by Pre-authorized Debit (PPD) {billingInfo?.ach_by_preauth ? 
                                    <IoMdCheckmark className="text-success ms-2" style={{ fontSize: '1.8rem' }} /> : 
                                    <FaTimes className="text-danger ms-2" style={{ fontSize: '1.8rem' }} />}
                                </p>
                            </div>
                            <div className="col-md-6 col-sm-6 mb-2">        
                                <p className="form-control-static d-flex align-items-center" style={{ gap: '1em'}}>
                                ACH Credit Txn Capacity (PPD) {billingInfo?.ach_credit_transaction ? 
                                    <IoMdCheckmark className="text-success ms-2" style={{ fontSize: '1.8rem' }} /> : 
                                    <FaTimes className="text-danger ms-2" style={{ fontSize: '1.8rem' }} />}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                </>
            )}

            {/* Defaults */}
            <h4 className="text-center">Default Pricing</h4>
            <div className="row">
                {default_prices.map((price) => (
                    <div className="col-md-6 col-sm-6 col-xs-6">
                        <p className={"form-control-static"}>
                            <b>{price.pricing_title}</b>: {price.dollars ? `$${price.dollars}` : '--'}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Pricing;
